const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/plan.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Group Plan Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/plan")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});